import { Box, Typography } from "@material-ui/core";
import { useAppSelector } from "../../../utils/hooks";
import { selectIsLocationOnline } from "../../../redux/generalSlice";
import locationOfflineStyles from "./LocationOffline.style";

const LocationOffline = () => {
  const classes = locationOfflineStyles();
  const isLocationOnline = useAppSelector(selectIsLocationOnline);

  if (!isLocationOnline) {
    return (
      <Box className={classes.container}>
        <Typography className={classes.text}>Location is offline</Typography>
      </Box>
    );
  }
  return null;
};

export default LocationOffline;
